import { useTranslations } from "@amtana/i18n";
import type { Translate } from "@amtana/i18n";

import { DESIGN_SYSTEM_CATALOGS } from "./design-system-copy.ts";
import type { DesignSystemCatalog } from "./design-system-copy.ts";

export function useDesignSystemCopy(): Translate<DesignSystemCatalog> {
  return useTranslations(DESIGN_SYSTEM_CATALOGS);
}
